import request from '../../utils/request'

export default {
  getAll: data => request({
    url: '/api/services/app/inComeStatistics/GetAll',
    method: 'get',
    params: data
  }),
  get: data => request({
    url: '/api/services/app/inComeStatistics/Get',
    method: 'get',
    params: data
  }),
  getForEdit: data => request({
     url: '/api/services/app/inComeStatistics/GetForEdit',
     method: 'get',
     params: data
  }),
  create: data => request({
    url: '/api/services/app/inComeStatistics/Create',
    method: 'post',
    data: data
  }),
  update: data => request({
    url: '/api/services/app/inComeStatistics/Update',
    method: 'put',
    data: data
  }),
  delete: function(data) {
    return request({
      url: '/api/services/app/inComeStatistics/delete',
      method: 'delete',
      params: data
    })
  }
}
